<script>
  import { getContext } from 'svelte'
  import { formatDateAxis, formatMillions } from '../functions.js'
  export let type = 'y'
  export let ticks = { x: null, y: null }
  export let scale = { x: null, y: null }
  export let height, width
  let { margin } = getContext('chart')
  export let manualYTicks
  export let manualXTicks
  export let xLabel = ''
</script>

<!-- {#if type === 'x'}
  {#each ticks.x as tick}
    <text class="axis x-axis" y={height - margin.bottom / 2} x={scale.x(tick)}
      >{{ tick }}</text
    >
  {/each} -->

{#if type === 'y'}
  {#each manualYTicks as tick}
    <text class="axis y-axis" x={margin.left - 10} y={scale.y(tick)}
      >{formatMillions(tick)}</text
    >
  {/each}
{/if}

{#if type === 'x'}
  {#each manualXTicks as tick}
    <line
      x1={scale.x(tick)}
      x2={scale.x(tick)}
      y1={height - margin.bottom / 2 - 5}
      y2={height - margin.bottom / 2 - 12}
    />
    <text
      class="axis x-axis"
      y={height - margin.bottom / 2 + 8}
      x={scale.x(tick)}>{tick}&nbsp;{xLabel}</text
    >
  {/each}
{/if}

<style>
  line {
    stroke: lightgray;
    stroke-width: 01px;
    shape-rendering: crispEdges;
  }
</style>
